import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BuildServerRule  {
    _originalTypeClassName = "zAppDevManager.BO.BuildServerRule";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BuildServerRule.translate = translateService;
}
this.Id = null;
this.ImplementationStrategyId = null;
this.SubscriptionId = null;
this.ApplicationId = null;
this.UserId = null;
this.BuildServerInstance = null;
this.Score = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ImplementationStrategyId:any;
SubscriptionId:any;
ApplicationId:any;
UserId:any;
BuildServerInstance:any;
Score:any;

static SerializeRow(row: any): any{let s = new Domain.BuildServerRule();
s.Id = Joove.Common.cast(row.get("Id"), "number");
s.SubscriptionId = Joove.Common.cast(row.get("SubscriptionId"), "number");
s.ApplicationId = Joove.Common.cast(row.get("ApplicationId"), "number");
s.UserId = Joove.Common.cast(row.get("UserId"), "number");
s.Score = Joove.Common.cast(row.get("Score"), "number");
s.ImplementationStrategyId = Joove.Common.cast(row.get("ImplementationStrategyId"), "string");
s.BuildServerInstance = Joove.Common.cast(row.get("BuildServerInstance"), "string");
return s;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}